import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'
import { useMe } from '../me'
import decamelizeKeys from 'decamelize-keys'
import { resolveEnvironment } from './environment'

/**
 * Only add data here that changes together with the session to avoid
 * unexpected data leaks. With cookieless tracking, a session is
 * in-memory and is limited to the current page.
 */
export const useRegister = () => {
  const postHog = usePostHog()
  const { me, isInternal } = useMe()
  const {
    account_id: persistedAccountId,
    user_category: persistedUserCategory,
  } = postHog?.persistence?.props ?? {}

  useEffect(() => {
    if (!me) return
    const userCategory = isInternal ? 'internal' : 'customer'
    const shouldSkipRegister =
      Number(persistedAccountId) === me?.accountId &&
      persistedUserCategory === userCategory

    if (shouldSkipRegister) {
      return
    }

    postHog.register(
      decamelizeKeys({
        clientId: 'back-office',
        environment: resolveEnvironment(me?.accountType),
        accountId: me?.accountId?.toString(),
        userCategory: userCategory,
      }),
    )
  }, [isInternal, postHog, persistedAccountId, persistedUserCategory, me])
}
